import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Row, Col, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";

import { logout, storeMe } from "./../app.slice";

import { useFetchMeQuery } from "./../pages/home/home.service";

function Header({ name, subName, onPress }) {
  const dispatch = useDispatch();
  const [curDate, setCurDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setCurDate(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    data: user,
    isError,
    isSuccess,
  } = useFetchMeQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isSuccess) dispatch(storeMe(user));
  }, [isSuccess, user]);

  useEffect(() => {
    if (isError) {
      dispatch(logout());
    }
  }, [isError]);

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={12} md={6}>
          <Button
            type="primary"
            size="large"
            className="header-sidebar-control"
            onClick={onPress}
            icon={<MenuOutlined />}
          ></Button>
        </Col>

        <Col span={12} md={18} className="header-control">
          <div style={{ fontSize: "15px", fontWeight: "bold" }}>
            {curDate.toLocaleString("en-US")}
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Header;
